import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import { Field } from "formik";

export default function InputCheckbox({
	name,
	label,
	disabled,
	sx,
	always_checked = false,
	alignItems = "center",
	fontSize = "16px",
	on_change = null,
}) {
	return (
		<Field type="checkbox" name={name} label={label}>
			{({ form, meta, field }) => {
				if (!form.values) {
					return;
				}

				if (form?.values[name] === Array[""]) {
					form.values[name] = false;
				}

				if (form?.values[name] === Array["on"]) {
					form.values[name] = true;
				}

				return (
					<FormControl error={Boolean(meta.error && meta.touched)} sx={sx}>
						<FormControlLabel
							sx={{ alignItems: alignItems }}
							control={
								<Checkbox
									size="small"
									checked={always_checked ? true : Boolean(form?.values[name])}
									{...field}
									onChange={(event) => {
										on_change ? on_change(event) : null;
										field.onChange(event);
									}}
								/>
							}
							disabled={disabled}
							id={name}
							label={
								<Box component="span" fontSize={fontSize}>
									{label}
								</Box>
							}
							{...field}
						/>
						{meta.error && meta.touched && (
							<FormHelperText sx={{ color: "error.main", mb: { xs: 1.5 }, mt: 0.5 }}>
								{meta.error}
							</FormHelperText>
						)}
					</FormControl>
				);
			}}
		</Field>
	);
}
